module.exports = __webpack_public_path__ + "static/media/EnergySmartLogo.52a5ceaf.svg";